/*
  assets/bh-free-tape.js  —  v1.0
  Bear Hollow Supply · 2026-10-02

  Free roll of template tape promo.

  When a customer adds a router template to the cart, this adds one
  roll of template tape to the cart with it. The "Free roll of
  template tape" automatic discount in Shopify makes that roll $0.

  Loaded only by snippets/template-addons.liquid (template product
  pages) and snippets/template-offer-banner.liquid (template
  collection page), and only while the promo is switched on there.
  The tape's variant id comes from window.BHFreeTape.variantId,
  which those snippets print.

  Rules:
  - Runs only right after the cart changes, never on page load.
  - Adds the tape only when the cart holds a router template
    (product type "Template") and no tape.
  - Adds it once. If the customer removes the tape it stays removed.
    Emptying the cart starts over.
  - Uses the same path as the theme's own Add to Cart: cart/add.js
    with the cart drawer section, then the theme's cartUpdate event.
    "cart:refresh" is not used.
*/
(function () {
  if (window.__bhFreeTapeLoaded) return;
  window.__bhFreeTapeLoaded = true;

  var cfg = window.BHFreeTape || {};
  var TAPE_ID = String(cfg.variantId || '');
  if (!TAPE_ID) return;

  var KEY = 'bhFreeTapeHandled';
  var TTL = 12 * 60 * 60 * 1000;
  var memHandled = false;
  var adding = false;

  function base() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function themeEvents() {
    if (window.FoxThemeEvents && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      return window.FoxThemeEvents;
    }
    return null;
  }

  function handled() {
    if (memHandled) return true;
    try {
      var t = Number(window.localStorage.getItem(KEY) || 0);
      return t > 0 && (Date.now() - t) < TTL;
    } catch (e) {
      return false;
    }
  }

  function setHandled() {
    memHandled = true;
    try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) {}
  }

  function clearHandled() {
    memHandled = false;
    try { window.localStorage.removeItem(KEY); } catch (e) {}
  }

  function drawerSections() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      drawer.getSectionsToRender().forEach(function (s) {
        if (s.id && ids.indexOf(s.id) === -1) ids.push(s.id);
      });
    }
    return ids;
  }

  function addTape() {
    adding = true;
    var payload = { items: [{ id: Number(TAPE_ID), quantity: 1 }] };
    var sections = drawerSections();
    if (sections.length) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }

    fetch(base() + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        // Shopify returns { status, message, description } when the add fails.
        if (response && response.status) {
          clearHandled();
          return;
        }
        var events = themeEvents();
        if (events && response && response.sections) {
          events.emit(PUB_SUB_EVENTS.cartUpdate, response);
        }
      })
      .catch(function () { clearHandled(); })
      .then(function () { adding = false; });
  }

  // Look at the real cart and decide. Called only after a cart change.
  function check() {
    if (adding) return;
    fetch(base() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (adding) return;
        var items = cart.items || [];
        var hasTape = false;
        var hasTemplate = false;
        items.forEach(function (item) {
          if (String(item.variant_id) === TAPE_ID) hasTape = true;
          if (item.product_type === 'Template') hasTemplate = true;
        });

        if (hasTape) { setHandled(); return; }
        if (!items.length) { clearHandled(); return; }
        if (!hasTemplate || handled()) return;

        setHandled();
        addTape();
      })
      .catch(function () {});
  }

  var tries = 0;
  function init() {
    var events = themeEvents();
    if (!events) {
      tries += 1;
      if (tries < 40) setTimeout(init, 250);
      return;
    }
    events.subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      setTimeout(check, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
